import { render } from "./IconSearchEmpty.vue?vue&type=template&id=19f6414a&ts=true"
import script from "./IconSearchEmpty.vue?vue&type=script&lang=ts"
export * from "./IconSearchEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__